/* eslint-disable max-len */
/* eslint-disable no-param-reassign */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { Spinner } from 'common/spinner';
import { appActions, AppContext } from 'context';
import { VaultsController } from 'networking/controllers/vaults-controller';
import React, {
  // useRef,
  useContext,
  useEffect,
  useState,
} from 'react';
// import globalStyles from 'assets/stylesheets/global-styles.module.scss';
import {
  classnames,
  // getAllMediaQueries,
  // getIndexClipSelectedInList,
  // copyToClipboard,
  // anyClipInProcess,
  // isRestrictedVault,
  // getSubscriptionSchemeById,
  // convertSecondsToTimeUnit,
  // isFreeTrial,
  // isOwner,
  // isContributor,
  // isGuest,
  // getVaultStatusLabel,
  // isReadOnlySubOrRestrictedVault,
  // isReadOnly,
  // getPermissionsByVault,
  // isChromeVersionWithIssues,
  // totalVaultVideoClips,
  // canUpgradeVault,
  // hasVaultReachedLimitMessage,
  // userPermissionUpgrade,
  // isTemporaryUser,
  // isAnyLoggedUser,
  getQueryParam,
  isChromeVersionWithIssues,
  isTemporaryUser,
} from 'helpers/utils';
import { Vault } from 'models/vault';
// import { useClickOutside } from 'hooks/click-outside';
// import {} from // UsersIcon,
// // MailIcon,
// // UserIcon,
// // EditIcon,
// // LinkIcon,
// // SettingsIcon,
// // BookIcon,
// // AlertTriangleIcon,
// // LockIcon,
// // MinusCircleIcon,
// 'assets/icons';
import { goToPage, RouteName } from 'routes';
import { vaultPageBreadcrumb } from 'helpers/vault-breadcrumbs';
// import { VideoClip } from 'common/video-clip';
// import { InfoModal } from 'common/info-modal';
// import { Menu } from 'common/menu';
import {
  // ImageSupportedExtensions,
  // apiBaseURL,
  errorsCodeInPayments,
} from 'config/constants';
import { NotificationObject } from 'models/notificationObject';
// import { Button, ButtonSize, ButtonStyle } from 'common/button';
// import { AllClipsList } from 'common/all-clips-list';
// import { AllClipsList } from 'common/all-clips-list';
import {
  VaultNavigationTabs,
  NavSections,
  NotificationType,
  PaymentType,
  SubscriptionStatus,
} from 'common/enums';
// import { Clip } from 'models/clip';
// import { VaultLimitedConditionWarning } from 'common/vault-limited-condition-warning';
// import { AllPaymentProcess } from 'common/all-payment-process';
import { AllPaymentProcess } from 'common/all-payment-process';
import { useHandleApiError } from 'hooks/use-handle-api-error';
// import { useFeatureFlags } from 'hooks/use-feature-flags';
// import { captureEvent } from 'posthog';
// import { QrCodesDetailsModal } from 'common/qr-codes-details-modal';
// import { QrCodesExplanationModal } from 'common/qr-codes-explanation-modal';
// import { AudioClip } from 'common/audio-clip';
// import { FileUploader } from 'common/file-uploader';
// import { AudioPlayer } from 'common/audio-player';
// import { SelfRecordingContext } from 'context/self-recording-context';
// import { selfRecordingActions } from 'context/self-recording-context/action-types';
// import { VaultLimitedConditionWarningType } from 'common/vault-limited-condition-warning/vault-limited-condition-warning';
import { AddPaymentMethodModal } from 'common/add-payment-method-modal';
import { ModalCardDeclined } from 'common/modal-card-declined';
// import { BuyClipsProcess } from 'common/buy-clips-process';
// import { ModalTemporaryUser } from 'common/modal-record-email/modal-temporary-user';
import { trackCustomEvent } from 'helpers/analytics';
// import { InviteToRecordProcess } from 'common/invite-to-record-process';
// import EmptyClipsBackgroundImage from 'assets/images/empty-clips-background.png';
// import { CopyLink } from 'common/copy-link/copy-link';
// import { Badge } from 'common/badge';
import { useVaultDetailNavigation } from 'hooks/use-vault-detail-navigation';
import { FinalOnboardingModal } from 'pages/final-onboarding-modal';
// import { ModalEditClip } from './components/modal-edit-clip';
// import { PlanInterview } from './components/plan-interview';
// import { ClipData } from './components/clip-data';
// import { VideoCallWaitingRoom } from './components/video-call-waiting-room';
// import { AboutVault } from './components/about-vault';
import {
  VaultDetailContext,
  VaultDetailProvider,
} from 'context/vault-detail-context';
import { vaultDetailActions } from 'context/vault-detail-context/action-types';
import styles from './vault-detail.module.scss';
// import {
//   VaultTab,
//   UpgradeVaultTab,
//   VaultTabMenu,
// } from './components/vault-tab';
// import { RequestVaultDownloadModal } from './components/request-vault-download-modal';
// import { RecordUpload } from './components/record-upload';
// import { OptionMenuType } from './components/vault-tab/vault-tab-menu';
import { VaultTopBar } from './components/vault-top-bar';
import { DraftVaultCheckout } from './components/draft-vault-checkout';
import { VaultTabsBar } from './components/vault-tabs-bar';
import { Dashboard } from './components/tabs/dashboard';
import { Albums } from './components/tabs/albums';
import { Memories } from './components/tabs/memories';
import { Timeline } from './components/tabs/timeline';

// const SHOW_PLAYLISTS = false;

// enum RecordOptions {
//   selfRecording = 'Record myself',
//   videoCall = 'Record on video call',
//   invite = 'Invite someone to record',
// }

const VaultDetailContent: React.FC = () => {
  const openUpgradeVault = !!new URLSearchParams(window.location.search).get(
    'upgradeVault',
  );

  const showModal = getQueryParam('showModal') ?? false;
  const {
    selectedTab,
    changeTab,
    vaultId: routeVaultId,
  } = useVaultDetailNavigation();

  const [showOnboardingFinalModal, setShowOnboardingFinalModal] =
    useState(showModal);

  const showTabs = () => {
    switch (selectedTab) {
      case VaultNavigationTabs.albums:
        return <Albums />;
      case VaultNavigationTabs.memories:
        return <Memories />;
      case VaultNavigationTabs.timeline:
        return <Timeline />;
      default:
        return <Dashboard />;
    }
  };

  // const getTabByQueryParam = () => {
  //   const selectedTab = new URLSearchParams(window.location.search).get(
  //     'tab',
  //   ) as VaultTabs;
  //   if (Object.values(VaultTabs).includes(selectedTab)) {
  //     if (
  //       [VaultTabs.selfRecording, VaultTabs.videoCall].includes(selectedTab)
  //     ) {
  //       return VaultTabs.recordAnswers;
  //     }
  //     return selectedTab;
  //   }

  //   return VaultNavigationTabs.albums;
  // };

  // const getRecordOptionByQueryParam = () => {
  //   const selectedTab = new URLSearchParams(window.location.search).get(
  //     'tab',
  //   ) as VaultTabs;
  //   switch (selectedTab) {
  //     case VaultTabs.recordAnswers:
  //     case VaultTabs.selfRecording:
  //       return RecordOptions.selfRecording;
  //     case VaultTabs.videoCall:
  //       return RecordOptions.videoCall;
  //     default:
  //       return null;
  //   }
  // };

  // const getClipByQueryParam = () => {
  //   const clipId = new URLSearchParams(window.location.search).get('clipId');

  //   return clipId ? +clipId : null;
  // };

  const { dispatch, state } = useContext(AppContext);
  const {
    state: { vaultId, refreshToken },
    dispatch: dispatchVaultDetail,
  } = useContext(VaultDetailContext);
  // const {
  //   state: { isRecording, isUploading, mode },
  //   dispatch: dispatchSelfRecording,
  // } = useContext(SelfRecordingContext);
  const [vault, setVault] = useState<VaultType>(new Vault());

  // const [clipSelected, setClipSelected] = useState<Clip>(new Clip());

  const [fetching, setFetching] = useState(true);

  // const [showRequestVaultDownloadModal, setShowRequestVaultDownloadModal] =
  //   useState(false);
  // const [showEditClipModal, setShowEditClipModal] = useState(false);
  // const [showQrCodesModal, setShowQrCodesModal] = useState(false);
  // const [showQrCodesExplanationModal, setShowQrCodesExplanationModal] =
  //   useState(false);
  // const [showLeavePageModal, setShowLeavePageModal] = useState(false);
  // const [showModalLeaveTemporary, setShowModalLeaveTemporary] = useState(false);
  // const [leavePageCallback, setLeavePageCallback] = useState<
  //   (() => void) | undefined
  // >(undefined);
  // const [showClipsListEnlarged, setShowClipsListEnlarged] = useState(false);

  // const [clipsOrder, setClipsOrder] = useState<ClipType[] | null>(null);

  // const [autoPlayingVideo, setAutoPlayingVideo] = useState(false);

  // const [showVaultOptions, setShowVaultOptions] = useState(false);

  // const [showLearnMoreSubscriptionModal, setShowLearnMoreSubscriptionModal] =
  //   useState(false);
  const [startPaymentProcess, setStartPaymentProcess] = useState(false);

  // const [clipsBeingProccesed, setClipsBeingProccesed] = useState<
  //   boolean | 'initial'
  // >('initial');
  // const containerVaultOptionsRef = useRef(null);
  // const clipIdUpload = useRef<number | null>(getClipByQueryParam());

  // const [showBuyClips, setShowBuyClipsModal] = useState<boolean>(false);

  const [showCardDeclinedModal, setShowCardDeclinedModal] = useState(false);
  const [showPaymentMethodModal, setShowPaymentMethodModal] = useState(false);
  // const [showModalSignUp, setModalSignUp] = useState(false);

  // const [showHeaderMenu, setShowHeaderMenu] = useState(false);

  // const [recordOptionSelected, setRecordOptionSelected] =
  //   useState<RecordOptions | null>(getRecordOptionByQueryParam());

  // const [showInviteToRecordProcess, setShowInviteToRecordProcess] =
  //   useState(false);

  const {
    // subscriptionsScheme,
    data: { user },
  } = state;

  const setApiError = useHandleApiError(() => {
    dispatch({
      type: appActions.NOTIFICATION,
      notification: new NotificationObject({ show: true }),
    });
  });

  // useClickOutside(containerVaultOptionsRef, () => setShowVaultOptions(false));

  // const mediaQueries = getAllMediaQueries();

  // const screenLowerXL = useMediaQuery(`(max-width: ${Breakpoints.xl}px)`);

  // const auxId = useRef<number>(1000);
  // const { vaultDownloadEnabled } = useFeatureFlags();

  // const maxQuestionAllowed = vault.maxClips;

  // const vaultPermissions =
  //   subscriptionsScheme && vault.subscriptionType
  //     ? getPermissionsByVault(subscriptionsScheme, vault)
  //     : undefined;

  // const showVaultDownload = useMemo(() => {
  //   if (!vault.clips || isLockedVault(vault)) return false;

  // Disable download if there are no clips with recordings attached
  //   return vault.clips?.filter((clip: ClipType) => clip.videoUrl).length > 0;
  // }, [vaultDownloadEnabled, vault.clips]);

  // const { withIcon, statusValue } = getVaultStatusLabel(vault);

  // const statusVaultHasIcon = !statusValue ? false : withIcon;

  const fetchVault = async () => {
    if (vaultId && vaultId > 0) {
      try {
        setFetching(true);
        const response = await VaultsController.getVault(vaultId, true);
        // if (response.clips?.length) {
        //   if (shouldUpdateClipSelected || response.clips.length === 1) {
        //     // const firstClip = response.clips[0];
        //     // setClipSelected(firstClip);
        //   }
        // }
        setVault(response);
        const allAlbums = [
          ...(response.albums || []),
          ...(response.unansweredAlbums || []),
        ];
        dispatchVaultDetail({
          type: vaultDetailActions.SET_INITIAL_ALBUMS,
          albums: allAlbums,
        });
      } catch (err: any) {
        goToPage(RouteName.VaultDetailGuest, { id: vaultId ?? 0 });
      } finally {
        setFetching(false);
      }
    }
  };

  useEffect(() => {
    if (vaultId) {
      fetchVault();
    }
  }, [vaultId]);

  // A memory created from the top-bar "New" modal lands straight in the API,
  // with no album screen around to patch the list locally — so re-read the
  // vault when one of those flows signals it finished.
  useEffect(() => {
    if (vaultId && refreshToken > 0) {
      fetchVault();
    }
  }, [refreshToken]);

  // const handleTabClose = (event: any) => {
  //   if ([VaultTabs.upload, VaultTabs.recordAnswers].includes(selectedTab)) {
  //     /* eslint-disable-next-line no-param-reassign, no-return-assign */
  //     return (event.returnValue = confirmationMsgLetUploadVideo);
  //   }
  //   return null;
  // };

  // const handleClickQrIcon = () => {
  //   setShowQrCodesModal(true);
  // };

  // useEffect(() => {
  //   setSelectedTab(getTabByQueryParam());
  //   setRecordOptionSelected(getRecordOptionByQueryParam());
  // }, [location]);

  useEffect(() => {
    if (isTemporaryUser(user)) {
      const handleBeforeUnload = (event: BeforeUnloadEvent) => {
        event.returnValue = '';
        // setShowModalLeaveTemporary(true);
        event.preventDefault();
      };

      window.addEventListener('beforeunload', handleBeforeUnload);
      return () => {
        window.removeEventListener('beforeunload', handleBeforeUnload);
      };
    }
    return () => {};
  }, []);

  // The vault itself is fetched by the `vaultId` effect above; fetching it here
  // as well made every vault page load the (large) payload twice.
  useEffect(() => {
    dispatch({
      type: appActions.ACTUAL_SECTION,
      actualSection: NavSections.vaults,
    });
  }, []);

  useEffect(() => {
    if (state.refetchVault) {
      fetchVault();
      dispatch({
        type: appActions.SET_REFETCH_VAULT,
        refetchVault: false,
      });
    }
  }, [state.refetchVault]);

  useEffect(() => {
    if (vault.id !== -1) {
      dispatch({
        type: appActions.SET_CURRENT_VAULT,
        currentVault: vault,
      });
    }

    return () => {
      dispatch({
        type: appActions.SET_CURRENT_VAULT,
      });
    };
  }, [vault]);

  useEffect(() => {
    if (isChromeVersionWithIssues()) {
      dispatch({
        type: appActions.NOTIFICATION,
        notification: new NotificationObject({
          show: true,
          title: 'Problems with your browser version',
          message:
            'Your browser might experience issues playing back videos. Consider updating your browser to get the best experience.',
          type: NotificationType.Error,
          limitTimeMs: 15000,
        }),
      });
    }
  }, []);

  const vaultDataExists = () => vault.id > -1;

  // useEffect(() => {
  //   window.addEventListener('scroll', () => {
  //     const scrollPos = window.scrollY; // position of scroll in y
  //     const windowHeight = window.innerHeight;

  //     if (scrollPos + windowHeight > 1200) {
  //       setShowClipsListEnlarged(true);
  //     } else {
  //       setShowClipsListEnlarged(false);
  //     }
  //   });
  // }, []);

  // useEffect(() => {
  //   window.addEventListener('beforeunload', handleTabClose);
  //   return () => {
  //     window.removeEventListener('beforeunload', handleTabClose);
  //   };
  // }, [selectedTab]);

  // useEffect(() => {
  //   if (clipIdUpload.current && vault.id > 0) {
  //     const newClipSelected = vault.clips?.find(
  //       (clip: ClipType) => clip.id === clipIdUpload.current,
  //     );

  //     if (newClipSelected) {
  //       setClipSelected(newClipSelected);
  //     }
  //   }

  //   if (clipsBeingProccesed === 'initial' && vaultDataExists()) {
  //     if (anyClipInProcess(vault.unansweredQuestions)) {
  //       setClipsBeingProccesed(true);
  //     } else {
  //       setClipsBeingProccesed(false);
  //     }
  //   }

  //   // For final clips update
  //   if (
  //     clipsBeingProccesed === true &&
  //     !anyClipInProcess(vault.unansweredQuestions)
  //   ) {
  //     setClipsBeingProccesed(false);
  //   }
  // }, [vault]);

  useEffect(() => {
    if (vaultDataExists() && openUpgradeVault) {
      setStartPaymentProcess(true);
    }
  }, [vaultDataExists()]);

  // useEffect(() => {
  //   let timer: NodeJS.Timeout;
  //   if (isAnyLoggedUser(user)) {
  //     if (clipsBeingProccesed === true) {
  //       timer = setInterval(() => {
  //         fetchVault(false);
  //       }, msToRecallVaultDetailEndpoint);
  //     }

  //     // Final clips update
  //     if (clipsBeingProccesed === false) {
  //       // Wait 12 seconds before fetch the vault to ensure the thumbnail is created
  //       timer = setTimeout(() => {
  //         fetchVault(false);
  //       }, msToRecallVaultDetailEndpoint * 4);
  //     }

  //     return () => {
  //       clearInterval(timer);
  //     };
  //   }
  //   return () => {};
  // }, [clipsBeingProccesed]);

  // const assignNewSelectedClipAfterFinishing = (
  //   clipList: ClipType[],
  //   indexClipSelected: number,
  // ) => {
  //   if (indexClipSelected !== clipList.length - 1) {
  //     setAutoPlayingVideo(true);

  //     const newSelectedClip = clipList[indexClipSelected + 1];
  //     setClipSelected(newSelectedClip);
  //   } else {
  //     setAutoPlayingVideo(false);
  //   }
  // };

  // const assignClipSelected = (
  //   deleteClipSelected: boolean,
  //   indexClipDeleted?: number,
  // ) => {
  //   if (vault.clips) {
  //     if (deleteClipSelected && indexClipDeleted) {
  //       if (indexClipDeleted === vault.clips.length - 1) {
  //         setClipSelected(vault.clips[0]);
  //       } else {
  //         setClipSelected(vault.clips[indexClipDeleted + 1]);
  //       }
  //     } else {
  //       setClipSelected(clipSelected);
  //     }
  //   }
  // };

  // const handleDeleteClip = async (clipIdToDelete: number) => {
  //   try {
  //     const deleteClipSelected = clipIdToDelete === clipSelected.id;

  //     const indexClipDeleted = await vault.clips?.findIndex(
  //       (item) => item.id === clipIdToDelete,
  //     );

  //     await VaultsController.deleteClip(clipIdToDelete);

  //     await fetchVault();

  //     assignClipSelected(deleteClipSelected, indexClipDeleted);
  //   } catch (err: any) {
  //     setApiError(err);
  //   }
  // };

  // const updateClipEditedInVault = (clipResponse: ClipType): void => {
  //   const clipsUpdated = vault.clips!.map((clip: ClipType) => {
  //     if (clip.id === clipResponse.id) {
  //       return clipResponse;
  //     }

  //     return clip;
  //   });

  //   setVault({ ...vault, clips: clipsUpdated });
  // };

  // const handleToggleAudioOnly = async (clipToChange: ClipType) => {
  //   try {
  //     const { name, description, isPrivate } = clipToChange;

  //     const requestData: ClipEditRequestType = {
  //       name,
  //       description,
  //       isPrivate,
  //       isAudioOnly: !clipToChange.isAudioOnly,
  //     };

  //     const clipResponse = await VaultsController.editClip(
  //       clipToChange.id,
  //       requestData,
  //     );

  //     updateClipEditedInVault(clipResponse);

  //     if (clipToChange.id === clipSelected.id) {
  //       setClipSelected(clipResponse);
  //     }
  //   } catch (err: any) {
  //     setApiError(err);
  //   }
  // };

  // const handleTogglePrivate = async (clipToChange: ClipType) => {
  //   try {
  //     const { name, description, isAudioOnly } = clipToChange;

  //     const requestData: ClipEditRequestType = {
  //       name,
  //       description,
  //       isAudioOnly,
  //       isPrivate: !clipToChange.isPrivate,
  //     };

  //     const clipResponse = await VaultsController.editClip(
  //       clipToChange.id,
  //       requestData,
  //     );

  //     updateClipEditedInVault(clipResponse);

  //     if (clipToChange.id === clipSelected.id) {
  //       setClipSelected(clipResponse);
  //     }
  //   } catch (err: any) {
  //     setApiError(err);
  //   }
  // };

  // const handleEditClip = () => {
  //   setShowEditClipModal(true);
  //   setAutoPlayingVideo(false);
  // };

  // const handleClipAction = (
  //   action: ClipActions,
  //   clip: ClipType,
  //   origin: 'clipDetail' | 'clipMenu',
  //   extraData?: ClipExtraDataType,
  // ) => {
  //   const analyticEventParams = { step: origin };
  //   switch (action) {
  //     case 'select':
  //       setClipSelected(clip);
  //       if (screenLowerXL) {
  //         window.scrollTo({ top: 0, behavior: 'smooth' });
  //       }
  //       if (extraData?.autoPlaying) {
  //         setAutoPlayingVideo(true);
  //       }
  //       break;
  //     case 'delete':
  //       trackCustomEvent('confirmDeleteClip');
  //       handleDeleteClip(clip.id);
  //       break;
  //     case 'togglePrivate': {
  //       const event = clip.isPrivate ? 'makeClipPublic' : 'makeClipPrivate';
  //       handleTogglePrivate(clip);
  //       trackCustomEvent(event, analyticEventParams);
  //       break;
  //     }
  //     case 'toggleAudioOnly': {
  //       const event = clip.isAudioOnly
  //         ? 'turnClipIntoVideo'
  //         : 'turnClipIntoAudioOnly';
  //       handleToggleAudioOnly(clip);
  //       trackCustomEvent(event, analyticEventParams);
  //       break;
  //     }
  //     case 'editClip':
  //       setClipSelected(clip);
  //       trackCustomEvent('startEditClip', analyticEventParams);
  //       handleEditClip();
  //       break;
  //     default:
  //       throw new Error('Unhandled action type');
  //   }
  // };

  // const handleSuccessEditClipModal = (clipResponse: ClipType) => {
  //   setShowEditClipModal(false);
  //   updateClipEditedInVault(clipResponse);
  //   setClipSelected(clipResponse);
  //   trackCustomEvent('confirmEditClip');
  // };

  // const handleSuccessEditQuestions = (unsQuestionsUpdated: QuestionType[]) => {
  //   setVault((prevState) => ({
  //     ...prevState,
  //     unansweredQuestions: unsQuestionsUpdated,
  //   }));

  //   dispatch({
  //     type: appActions.NOTIFICATION,
  //     notification: new NotificationObject({
  //       show: true,
  //       noMessage: true,
  //       type: NotificationType.Success,
  //     }),
  //   });
  // };

  // const handleCloseEditClipModal = () => {
  //   setShowEditClipModal(false);
  // };

  // const showEditClipModalComponent = () => (
  //   <ModalEditClip
  //     onClose={() => handleCloseEditClipModal()}
  //     onSuccess={(clipEdited: ClipType) =>
  //       handleSuccessEditClipModal(clipEdited)
  //     }
  //     clip={clipSelected}
  //   />
  // );

  const handleModifyVaultSubscription = async (
    newTier: SubscriptionSchemeId,
  ) => {
    try {
      await VaultsController.modifyVaultSubscription(vault.id, newTier);
      return vault;
    } catch (err: any) {
      setApiError(err);
      const isPaymentError = err?.errors?.some(
        (error: any) => error.errorCode === errorsCodeInPayments.cardDeclined,
      );
      if (isPaymentError) {
        setShowCardDeclinedModal(true);
      }
      return null;
    }
  };

  const handleError = () => {
    setStartPaymentProcess(false);

    dispatch({
      type: appActions.NOTIFICATION,
      notification: new NotificationObject({
        show: true,
        title: 'Modify Vault',
        message: 'Subscription failed.',
        type: NotificationType.Error,
      }),
    });
  };

  const handleSuccessPayment = async () => {
    setStartPaymentProcess(false);

    dispatch({
      type: appActions.NOTIFICATION,
      notification: new NotificationObject({
        show: true,
        title: 'Modify Vault',
        message: 'Subscription modified successful.',
        type: NotificationType.Success,
      }),
    });

    fetchVault();

    trackCustomEvent('confirmUpgradeVault');
  };

  const showAllPaymentProcessComponent = () => (
    <AllPaymentProcess
      vaultReceived={vault}
      paymentType={PaymentType.ModifyVaultSubscription}
      successPaymentTextBody="Your subscription has been successfully modified."
      failedPaymentTextBody="Your subscription could not be modified. Please review your payment method and try again."
      notifyProcessConfirmation={(newTier?: SubscriptionSchemeId) =>
        handleModifyVaultSubscription(newTier!)
      }
      cancelPaymentProcess={() => setStartPaymentProcess(false)}
      successPaymentProcess={handleSuccessPayment}
      notifyError={handleError}
      failedPaymentProcess={() => {
        setStartPaymentProcess(false);
      }}
    />
  );

  // const handleEditVaultModal = () => {
  //   setAutoPlayingVideo(false);
  //   setShowEditVaultModal(true);
  //   trackCustomEvent('startEditVault');
  // };

  // const showDeleteVaultOption = () => (
  //   <>
  //     <div className={styles.lineSeparator} />
  //     <button
  //       type="button"
  //       onClick={() => handleDeleteVaultModal()}
  //       className="text__body__regular__medium__danger40"
  //     >
  //       Delete vault
  //     </button>
  //   </>
  // );

  // const showEditVaultOption = () => (
  //   <button
  //     type="button"
  //     onClick={() => handleEditVaultModal()}
  //     className={classnames('text__body__regular__medium__gray700')}
  //   >
  //     Edit vault info
  //   </button>
  // );

  // const showQrCodesOption = () => (
  //   <button
  //     type="button"
  //     onClick={handleClickQrIcon}
  //     className={classnames(
  //       styles.copyLinkOption,
  //       'text__body__regular__medium__gray700',
  //     )}
  //   >
  //     QR Code(s)
  //   </button>
  // );

  // const showCopyLinkOption = () => (
  //   <button
  //     type="button"
  //     onClick={
  //       isTemporaryUser(user)
  //         ? () => setModalSignUp(true)
  //         : () => {
  //             copyToClipboard(
  //               `${apiBaseURL}${getRouteFor(RouteName.VaultDetailGuest, {
  //                 id: vault.id,
  //               })}`,
  //             );
  //             trackCustomEvent('copyLinkToVault');
  //           }
  //     }
  //     className={classnames(
  //       styles.copyLinkOption,
  //       'text__body__regular__medium__gray700',
  //     )}
  //   >
  //     Copy link to vault
  //   </button>
  // );

  // const showDownloadVaultOption = () => (
  //   <button
  //     type="button"
  //     onClick={
  //       isTemporaryUser(user)
  //         ? () => setModalSignUp(true)
  //         : () => {
  //             setShowRequestVaultDownloadModal(true);
  //             trackCustomEvent('startRequestVaultDownload');
  //           }
  //     }
  //     className="text__body__regular__medium__gray700"
  //   >
  //     Request download
  //   </button>
  // );

  // const getOnlyQuestionTypeProps = (clips: ClipType[] = []): QuestionType[] =>
  //   clips.map((clip) => {
  //     auxId.current += 1;

  //     return {
  //       id: clip.id,
  //       name: clip.name,
  //       auxId: auxId.current.toString(),
  //       createdBy: clip.createdBy,
  //       recordedBy: clip.recordedBy,
  //       createdByOwner: clip.createdByOwner,
  //       recordedByOwner: clip.recordedByOwner,
  //       recordingStatus: clip.recordingStatus,
  //     } as QuestionType;
  //   });
  // const vaultOptionsMenu = () => (
  //   <Menu width={styles.vaultOptionsWidth}>
  //     {!isLockedVault(vault) && showQrCodesOption()}
  //     {!isLockedVault(vault) && showCopyLinkOption()}
  //     {isOwner(user, vault) &&
  //       !isReadOnly(vault) &&
  //       !isRestrictedVault(vault) &&
  //       !isLockedVault(vault) &&
  //       showEditVaultOption()}
  //     {showVaultDownload && showDownloadVaultOption()}
  //     {isOwner(user, vault) &&
  //       user.permissions?.permissions.deleteVaults &&
  //       showDeleteVaultOption()}
  //   </Menu>
  // );

  // const showVaultOptionsButton = () => (
  //   <div
  //     className={classnames(
  //       showHeaderMenu ? styles.dotsActive : styles.vaultDots,
  //       styles.rightFromLeftSectionHeaderButton,
  //     )}
  //   >
  //     <div
  //       role="button"
  //       tabIndex={0}
  //       ref={containerVaultOptionsRef}
  //       key={vault.id}
  //       className={classnames(
  //         globalStyles.threeDots,
  //         styles.dotsColor,
  //         styles.paddingDots,
  //       )}
  //       onClick={() => {
  //         setShowHeaderMenu((prev) => !prev);
  //         setShowVaultOptions(!showVaultOptions);
  //         trackCustomEvent('openVaultMenu');
  //       }}
  //     >
  //       {showVaultOptions && vaultOptionsMenu()}
  //     </div>
  //   </div>
  // );

  // const showWarningProcessingClips = () => (
  //   <VaultLimitedConditionWarning
  //     title="Your video call is being processed"
  //     content={
  //       <div className="text__body__regular__medium__gray800">
  //         You will be able to see and modify your clips once they finish
  //         uploading.
  //       </div>
  //     }
  //     type={VaultLimitedConditionWarningType.Info}
  //   />
  // );

  // const moveSelectedTab = (queryParams: ParamsType) => {
  //   if (queryParams.tab === VaultTabs.upload) {
  //     dispatchSelfRecording({
  //       type: selfRecordingActions.setMode,
  //       mode: 'upload',
  //     });
  //   }
  //   const newUrl = getRouteFor(
  //     RouteName.VaultDetail,
  //     { id: vault.id },
  //     queryParams,
  //   );
  //   window.history.pushState({ path: newUrl }, '', newUrl);
  //   const tab = [VaultTabs.videoCall, VaultTabs.selfRecording].includes(
  //     queryParams.tab,
  //   )
  //     ? VaultTabs.recordAnswers
  //     : queryParams.tab;
  //   setSelectedTab(tab);
  // };

  // const handleTabSelected = (queryParams: ParamsType) => {
  //   captureEvent('selectVaultTab', { tab: queryParams.tab });
  //   trackCustomEvent('selectVaultTab', { tab: queryParams.tab });
  //   const shouldDisplayWarning =
  //     [VaultTabs.upload, VaultTabs.recordAnswers].includes(selectedTab) &&
  //     ![VaultTabs.upload, VaultTabs.recordAnswers].includes(queryParams.tab) &&
  //     (isRecording || isUploading);
  //   if (shouldDisplayWarning) {
  //     setShowLeavePageModal(true);
  //     setLeavePageCallback(() => () => moveSelectedTab(queryParams));
  //   } else {
  //     if (
  //       [VaultTabs.recordAnswers, VaultTabs.selfRecording].includes(
  //         queryParams.tab,
  //       )
  //     ) {
  //       setRecordOptionSelected(RecordOptions.selfRecording);
  //       dispatchSelfRecording({
  //         type: selfRecordingActions.setMode,
  //         mode: 'record',
  //       });
  //     }
  //     if (queryParams.tab === VaultTabs.videoCall) {
  //       setRecordOptionSelected(RecordOptions.videoCall);
  //     }
  //     moveSelectedTab(queryParams);
  //   }
  // };

  // const recordOptions: OptionMenuType[] = [
  //   {
  //     name: RecordOptions.selfRecording,
  //     icon: <UserIcon />,
  //     handleOptionSelected: () => {
  //       handleTabSelected({ tab: VaultTabs.selfRecording });
  //     },
  //   },
  //   {
  //     name: RecordOptions.videoCall,
  //     icon: <UsersIcon />,
  //     handleOptionSelected: () => {
  //       handleTabSelected({ tab: VaultTabs.videoCall });
  //     },
  //   },
  //   {
  //     name: RecordOptions.invite,
  //     icon: <MailIcon />,
  //     handleOptionSelected: () => {
  //       setShowInviteToRecordProcess(true);
  //     },
  //   },
  // ];

  // const showEmptyPage = () => {
  //   let title = '';
  //   let description = '';
  //   let buttons = [];
  //   if (isLockedVault(vault)) {
  //     title = 'Your vault is locked';
  //     description =
  //       'This means your subscription has ended or an issue with a payment has occurred. Please contact support at support@generationalstory.com if you need help.';
  //     buttons = [
  //       {
  //         title: 'Review payments',
  //         action: () => changeTab(VaultTabs.settings),
  //       },
  //       {
  //         title: 'Contact support',
  //         action: () => {
  //           window.location.href = 'mailto:support@generationalstory.com';
  //         },
  //       },
  //     ];
  //   } else if (vault.unansweredQuestions?.length) {
  //     title = "You've got your prompts ready. Let's record your first video.";
  //     description =
  //       'Start by selecting prompts, or jump straight into recording your story.';
  //     buttons = [
  //       {
  //         title: "Let's get started",
  //         action: () => handleTabSelected({ tab: VaultTabs.recordAnswers }),
  //       },
  //     ];
  //   } else {
  //     title = "Let's get started";
  //     description =
  //       'Start by selecting prompts, or jump straight into recording your story.';
  //     buttons = [
  //       {
  //         title: 'Select prompts',
  //         action: () => handleTabSelected({ tab: VaultTabs.addPrompts }),
  //       },
  //       {
  //         title: 'Start recording',
  //         action: () => handleTabSelected({ tab: VaultTabs.recordAnswers }),
  //         buttonStyle: ButtonStyle.PrimaryStroke,
  //       },
  //     ];
  //   }

  // return (
  //   <>
  //     {anyClipInProcess(vault.unansweredQuestions) &&
  //       showWarningProcessingClips()}
  //     <div className={styles.emptyPage}>
  //       <img alt="background-image" src={EmptyClipsBackgroundImage} />
  //       <div className={styles.emptyMessageContainer}>
  //         <div className={styles.emptyMessageText}>
  //           <p
  //             className={classnames(
  //               'text__heading3__gray700',
  //               styles.headingEmpty,
  //             )}
  //           >
  //             {title}
  //           </p>
  //           <p className="text__body__regular__medium__gray700">
  //             {description}
  //           </p>
  //           <div className={styles.emptyPageButtons}>
  //             {buttons.map((button) => (
  //               <Button
  //                 onClick={button.action}
  //                 buttonStyle={button.buttonStyle}
  //               >
  //                 {button.title}
  //               </Button>
  //             ))}
  //           </div>
  //         </div>
  //       </div>
  //     </div>
  //   </>
  //   );
  // };

  // const handleOnEndedClip = () => {
  //   let clipsListCopy = [...vault.clips!];
  //   if (clipsOrder) {
  //     clipsListCopy = clipsOrder;
  //   }

  //   const clipSelectedIndex = getIndexClipSelectedInList(
  //     clipsListCopy,
  //     clipSelected,
  //   );
  //   assignNewSelectedClipAfterFinishing(clipsListCopy, clipSelectedIndex!);
  // };

  // const handleOnPlayClip = () => {
  //   setAutoPlayingVideo(true);
  // };

  // const getVaultStatus = () => {
  //   let styleName = statusValue?.toLowerCase() || 'status';
  //   let icon;

  //   switch (statusValue) {
  //     case 'Locked':
  //       icon = <LockIcon className={styles.icon} />;
  //       break;
  //     case 'Restricted':
  //       icon = <AlertTriangleIcon className={styles.icon} />;
  //       break;
  //     case 'Canceled':
  //       icon = <MinusCircleIcon className={styles.icon} />;
  //       break;
  //     default:
  //       styleName = statusValue?.toLowerCase() || 'status';
  //       icon = null;
  //   }

  //   return (
  //     statusVaultHasIcon && (
  //       <Badge
  //         className={styles[styleName]}
  //         icon={icon}
  //         message={statusValue?.toUpperCase()}
  //       />
  //     )
  //   );
  // };

  // const shouldShowVaultOptions = () =>
  //   isOwner(user, vault) || (isContributor(user, vault) && mediaQueries.md);

  // const showTabs = () => (
  //   <div className={styles.allTabs}>
  //     <div id="clips-tab">
  //       {' '}
  //       {/* ref={clipsTabRef} */}
  //       <VaultTab
  //         selectedTab={selectedTab}
  //         tab={VaultTabs.clips}
  //         handleTabSelected={handleTabSelected}
  //       />
  //     </div>
  //     <div id="add-prompts-tab">
  //       {' '}
  //       {/* ref={addPromptsTabRef} */}
  //       <VaultTab
  //         selectedTab={selectedTab}
  //         tab={VaultTabs.addPrompts}
  //         handleTabSelected={handleTabSelected}
  //         disabled={isRestrictedVault(vault) || isLockedVault(vault)}
  //       />
  //     </div>
  //     <VaultTabMenu
  //       selectedTab={selectedTab}
  //       tab={VaultTabs.recordAnswers}
  //       disabled={
  //         isRestrictedVault(vault) ||
  //         isLockedVault(vault) ||
  //         !vaultPermissions?.addOrRecordClips
  //       }
  //       menuOptions={recordOptions}
  //       // scrollContainerRef={tabsRef}
  //       // menuRefProp={recordAnswersMenuRef}
  //       // tabRefProp={recordAnswersTabRef}
  //       notifyMenuOpen={() => {}}
  //     />
  //     {SHOW_PLAYLISTS && (
  //       <VaultTab
  //         selectedTab={selectedTab}
  //         tab={VaultTabs.playlists}
  //         disabled={isRestrictedVault(vault) || isLockedVault(vault)}
  //         handleTabSelected={handleTabSelected}
  //       />
  //     )}
  //     <div id="upload-tab">
  //       {/* ref={uploadTabRef} into the div */}
  //       <VaultTab
  //         selectedTab={selectedTab}
  //         tab={VaultTabs.upload}
  //         handleTabSelected={handleTabSelected}
  //         disabled={
  //           isRestrictedVault(vault) ||
  //           isLockedVault(vault) ||
  //           !vaultPermissions?.addOrRecordClips
  //         }
  //       />
  //     </div>
  //     {isOwner(user, vault) &&
  //       canUpgradeVault(vault, subscriptionsScheme) &&
  //       !isTemporaryUser(user) && (
  //         <UpgradeVaultTab
  //           onClick={startUpgradeProcess}
  //           showSecondaryColor={maxQuestionAllowed === vault.clipAmount}
  //         />
  //       )}
  //   </div>
  // );

  // const handleRemovePicture = async () => {
  //   const requestData: ClipEditRequestType = {
  //     customThumbnailSignedId: null,
  //     isAudioOnly: clipSelected.isAudioOnly,
  //     name: clipSelected.name,
  //     description: clipSelected.description,
  //     isPrivate: clipSelected.isPrivate,
  //   };
  //   try {
  //     const response = await VaultsController.editClip(
  //       clipSelected.id,
  //       requestData,
  //     );
  //     updateClipEditedInVault(response);
  //     setClipSelected(response);
  //   } catch (err: any) {
  //     dispatch({
  //       type: appActions.NOTIFICATION,
  //       notification: new NotificationObject({
  //         show: true,
  //         title: 'Something went wrong',
  //         message: 'Please try again.',
  //       }),
  //     });
  //   }
  // };

  // const handleImageUpload = async ({ signedId: idImage }: FileResponseType) => {
  //   const requestData: ClipEditRequestType = {
  //     customThumbnailSignedId: idImage,
  //     isAudioOnly: clipSelected.isAudioOnly,
  //     name: clipSelected.name,
  //     description: clipSelected.description,
  //     isPrivate: clipSelected.isPrivate,
  //   };
  //   try {
  //     trackCustomEvent('attachClipImage');
  //     const response = await VaultsController.editClip(
  //       clipSelected.id,
  //       requestData,
  //     );
  //     updateClipEditedInVault(response);
  //     setClipSelected(response);
  //   } catch (err: any) {
  //     dispatch({
  //       type: appActions.NOTIFICATION,
  //       notification: new NotificationObject({
  //         show: true,
  //         title: 'Something went wrong',
  //         message: 'Please try again.',
  //       }),
  //     });
  //   }
  // };
  // const showAudioOption = () =>
  //   clipSelected.customThumbnail ? (
  //     <AudioClip
  //       videoUrl={clipSelected.videoUrl}
  //       image={clipSelected.customThumbnail}
  //       alt={clipSelected.name}
  //     />
  //   ) : (
  //     <div className={styles.fileUploaderContainer}>
  //       {!isReadOnlySubOrRestrictedVault(vault) && (
  //         <div className={styles.fileUploader}>
  //           <FileUploader
  //             uploadingMessage="Uploading photo"
  //             supportedExtensions={ImageSupportedExtensions}
  //             maxFileSizeInMb={mbVaultCoverMaxSize}
  //             onLoading={() => {}}
  //             onSuccess={handleImageUpload}
  //             onError={() => {}}
  //             onCancel={() => {}}
  //             message="Drag and drop a related image to your clip to help tell your story or"
  //           />
  //         </div>
  //       )}
  //       <AudioPlayer videoUrl={clipSelected.videoUrl} />
  //     </div>
  //   );
  // const showClipsBody = () => (
  //   <div className={styles.clipsSection}>
  //     <div className={styles.clipVideoAndDescription}>
  //       {clipSelected.isAudioOnly ? (
  //         showAudioOption()
  //       ) : (
  //         <VideoClip
  //           autoPlaying={autoPlayingVideo}
  //           clipSelected={clipSelected}
  //           notifyOnEnded={() => handleOnEndedClip()}
  //           notifyOnPlay={() => handleOnPlayClip()}
  //         />
  //       )}
  //       <ClipData
  //         vault={vault}
  //         clipSelected={clipSelected}
  //         notifyClipAction={(action: ClipActions, clip: ClipType) => {
  //           handleClipAction(action, clip, 'clipDetail');
  //         }}
  //         notifyShowQrCodesExplanation={() =>
  //           setShowQrCodesExplanationModal(true)
  //         }
  //         handleImageUpload={handleImageUpload}
  //         handleRemovePicture={handleRemovePicture}
  //       />
  //     </div>
  //     <div
  //       className={
  //         showClipsListEnlarged ? styles.clipsListEnlarged : styles.clipsList
  //       }
  //     >
  //       <AllClipsList
  //         vault={vault}
  //         clipSelected={clipSelected}
  //         notifyClipAction={(
  //           action: ClipActions,
  //           clip: ClipType,
  //           extraData?: ClipExtraDataType,
  //         ) => {
  //           handleClipAction(action, clip, 'clipMenu', extraData);
  //         }}
  //         notifyStopClip={() => setAutoPlayingVideo(false)}
  //         notifyChangeClipOrder={(clips: ClipType[]) => setClipsOrder(clips)}
  //       />
  //     </div>
  //   </div>
  // );

  // const showPlanInterviewBody = () => (
  //   <div className={styles.interviewSection}>
  //     <PlanInterview
  //       vault={vault}
  //       maxQuestionsAllowed={vault.maxClips}
  //       unansweredQuestions={getOnlyQuestionTypeProps(
  //         vault.unansweredQuestions,
  //       )}
  //       notifySucess={(UnasQuestionsUpdated) =>
  //         handleSuccessEditQuestions(UnasQuestionsUpdated)
  //       }
  //       handleTabSelected={handleTabSelected}
  //     />
  //   </div>
  // );

  const showOnboardingModal = () => (
    <FinalOnboardingModal
      vaultTitle={vault.title}
      vaultImage={vault.coverUrl ?? ''}
      onClose={() => setShowOnboardingFinalModal(false)}
    />
  );

  // const showVideoCallWaitingRoomBody = () => (
  //   <div className={styles.videoCallSection}>
  //     <VideoCallWaitingRoom
  //       vault={vault}
  //       upgradeVault={() => setStartPaymentProcess(true)}
  //       handleTabChange={(tabName: VaultTabs) =>
  //         handleTabSelected({ tab: tabName })
  //       }
  //     />
  //   </div>
  // );

  // const warningFreeVaultReachedLimitContent = (contributor: boolean) => {
  //   if (contributor) {
  //     return (
  //       <span
  //         className={classnames(
  //           'text__body__regular__medium__gray800',
  //           styles.bodyDescription,
  //         )}
  //       >
  //         Contact the vault owner to upgrade their subscription to keep
  //         recording.
  //       </span>
  //     );
  //   }
  //   return (
  //     <div>
  //       <Button
  //         buttonStyle={ButtonStyle.SecondaryGhostLink}
  //         buttonSize={ButtonSize.Medium}
  //         onClick={startUpgradeProcess}
  //       >
  //         Upgrade to a subscription
  //       </Button>
  //       <span
  //         className={classnames(
  //           'text__body__regular__medium__gray800',
  //           styles.bodyDescription,
  //         )}
  //       >
  //         {' '}
  //         to increase your limit.{' '}
  //       </span>
  //     </div>
  //   );
  // };

  // const warningFreeVaultAlmostFullContent = (
  //   totalClips: number,
  //   clipsLimit: number,
  //   contributor: boolean,
  // ) => (
  //   <div>
  //     <span
  //       className={classnames(
  //         'text__body__regular__medium__gray800',
  //         styles.bodyDescription,
  //       )}
  //     >
  //       You’ve recorded {totalClips} out of {clipsLimit} available clips.{' '}
  //     </span>
  //     {contributor ? (
  //       <span
  //         className={classnames(
  //           'text__body__regular__medium__gray800',
  //           styles.bodyDescription,
  //         )}
  //       >
  //         Contact the vault owner to upgrade their subscription to keep
  //         recording.
  //       </span>
  //     ) : (
  //       <>
  //         <Button
  //           buttonStyle={ButtonStyle.PrimaryGhostLink}
  //           buttonSize={ButtonSize.Medium}
  //           onClick={startUpgradeProcess}
  //         >
  //           Upgrade to a subscription
  //         </Button>
  //         <span
  //           className={classnames(
  //             'text__body__regular__medium__gray800',
  //             styles.bodyDescription,
  //           )}
  //         >
  //           {' '}
  //           to increase your limit.{' '}
  //         </span>
  //       </>
  //     )}
  //   </div>
  // );

  // const warningVaultAlmostFullContent = (
  //   alb: VaultType,
  //   warningType: VaultLimitedConditionWarningType,
  //   contributor: boolean,
  //   subsScheme?: SubscriptionTypeType[],
  // ) => (
  //   <div>
  //     <span
  //       className={classnames(
  //         'text__body__regular__medium__gray800',
  //         styles.bodyDescription,
  //       )}
  //     >
  //       You’ve recorded {totalVaultVideoClips(alb)} out of {alb.maxClips}{' '}
  //       available clips.{' '}
  //     </span>
  //     {contributor ? (
  //       <span
  //         className={classnames(
  //           'text__body__regular__medium__gray800',
  //           styles.bodyDescription,
  //         )}
  //       >
  //         Contact the vault owner to purchase extra clips or upgrade their
  //         subscription for extra storage.
  //       </span>
  //     ) : (
  //       <>
  //         <span
  //           className={classnames(
  //             'text__body__regular__medium__gray800',
  //             styles.bodyDescription,
  //           )}
  //         >
  //           Get extra storage by{' '}
  //         </span>
  //         <Button
  //           buttonStyle={
  //             warningType === VaultLimitedConditionWarningType.Alert
  //               ? ButtonStyle.SecondaryGhostLink
  //               : ButtonStyle.PrimaryGhostLink
  //           }
  //           buttonSize={ButtonSize.Medium}
  //           onClick={() => {
  //             setShowBuyClipsModal(true);
  //           }}
  //         >
  //           purchasing extra clips
  //         </Button>
  //         {canUpgradeVault(alb, subsScheme) && (
  //           <>
  //             {' '}
  //             <span
  //               className={classnames(
  //                 'text__body__regular__medium__gray800',
  //                 styles.bodyDescription,
  //               )}
  //             >
  //               {' '}
  //               or{' '}
  //             </span>
  //             <Button
  //               buttonStyle={
  //                 warningType === VaultLimitedConditionWarningType.Alert
  //                   ? ButtonStyle.SecondaryGhostLink
  //                   : ButtonStyle.PrimaryGhostLink
  //               }
  //               buttonSize={ButtonSize.Medium}
  //               onClick={startUpgradeProcess}
  //             >
  //               upgrading your subscription
  //             </Button>
  //           </>
  //         )}
  //         <span
  //           className={classnames(
  //             'text__body__regular__medium__gray800',
  //             styles.bodyDescription,
  //           )}
  //         >
  //           .
  //         </span>
  //       </>
  //     )}
  //   </div>
  // );

  // const warningRestrictedVaultContent = () => (
  //   <div>
  //     <p className={classnames('text__body__regular__small__gray800')}>
  //       Your vault’s payment method couldn’t be charged and your vault has been
  //       restricted to view only.
  //     </p>

  //     <div>
  //       <Button
  //         buttonStyle={ButtonStyle.SecondaryGhostLink}
  //         buttonSize={ButtonSize.Small}
  //         onClick={() => {
  //           goToPage(RouteName.Account, {}, { 'add-payment-method': true });
  //         }}
  //       >
  //         Update your payment method
  //       </Button>
  //       <span className={classnames('text__body__regular__small__gray800')}>
  //         &nbsp; to restore your vault.
  //       </span>
  //     </div>
  //   </div>
  // );

  // const showWarningVaultLimitedCondition = (
  //   message: string,
  //   content: ReactNode | string,
  //   type: VaultLimitedConditionWarningType,
  // ) => (
  //   <VaultLimitedConditionWarning
  //     title={message}
  //     content={content}
  //     type={type}
  //   />
  // );

  // const readOnlyContent = () => (
  //   <span
  //     className={classnames(
  //       'text__body__regular__medium__gray800',
  //       styles.bodyDescription,
  //     )}
  //   >
  //     <Button
  //       buttonStyle={ButtonStyle.PrimaryGhostLink}
  //       buttonSize={ButtonSize.Medium}
  //       onClick={startUpgradeProcess}
  //     >
  //       Upgrade your subscription
  //     </Button>{' '}
  //     to add new clips to your vault and access all of Generational Story’s
  //     features.
  //   </span>
  // );

  // const verifyVaultConditionWarning = (alb: VaultType, tab: VaultTabs) => {
  //   let message;
  //   const warningType =
  //     totalVaultVideoClips(alb) >= alb.maxClips
  //       ? VaultLimitedConditionWarningType.Alert
  //       : VaultLimitedConditionWarningType.Info;

  //   if (!userPermissionUpgrade(user)) {
  //     return null;
  //   }

  //   if (isRestrictedVault(alb)) {
  //     message = 'Your vault has been restricted to view only';
  //     return showWarningVaultLimitedCondition(
  //       message,
  //       warningRestrictedVaultContent(),
  //       VaultLimitedConditionWarningType.Alert,
  //     );
  //   }
  //   if (isReadOnly(alb)) {
  //     message = 'This is a read only vault';
  //     return showWarningVaultLimitedCondition(
  //       message,
  //       readOnlyContent(),
  //       VaultLimitedConditionWarningType.Info,
  //     );
  //   }

  //   message = hasVaultReachedLimitMessage(alb, tab) || '';
  //   const warningContentFreeTrial =
  //     warningType === VaultLimitedConditionWarningType.Alert
  //       ? warningFreeVaultReachedLimitContent(isContributor(user, vault))
  //       : warningFreeVaultAlmostFullContent(
  //           totalVaultVideoClips(alb),
  //           alb.maxClips,
  //           isContributor(user, vault),
  //         );

  //   if (message) {
  //     return showWarningVaultLimitedCondition(
  //       message,
  //       isFreeTrial(alb)
  //         ? warningContentFreeTrial
  //         : warningVaultAlmostFullContent(
  //             alb,
  //             warningType,
  //             isContributor(user, vault),
  //             subscriptionsScheme,
  //           ),
  //       warningType,
  //     );
  //   }

  //   return null;
  // };

  // const showAboutVaultBody = () => (
  //   <AboutVault
  //     vault={vault}
  //     refetchVault={fetchVault}
  //     handleTabChange={(tabName: VaultTabs) =>
  //       handleTabSelected({ tab: tabName })
  //     }
  //   />
  // );
  // const fakeRefForLints = useRef<HTMLDivElement>(null);

  // useEffect(() => {
  //   let helpSection: HelpInfoSections | undefined;

  //   switch (selectedTab) {
  //     case VaultTabs.clips:
  //       helpSection = vault.clips?.length
  //         ? HelpInfoSections.vault_clips
  //         : HelpInfoSections.vault_clips_empty;
  //       break;
  //     case VaultTabs.addPrompts:
  //       helpSection = vault.unansweredQuestions?.length
  //         ? HelpInfoSections.add_prompts_filled
  //         : HelpInfoSections.add_prompts_empty;
  //       break;
  //     case VaultTabs.recordAnswers:
  //       if (recordOptionSelected === RecordOptions.videoCall) {
  //         helpSection = HelpInfoSections.video_call;
  //       } else if (recordOptionSelected === RecordOptions.selfRecording) {
  //         helpSection = vault.unansweredQuestions?.length
  //           ? HelpInfoSections.record_filled
  //           : HelpInfoSections.record_empty;
  //       }
  //       break;
  //     case VaultTabs.settings:
  //       helpSection = HelpInfoSections.vault_settings;
  //       break;
  //     case VaultTabs.upload:
  //       helpSection = vault.unansweredQuestions?.length
  //         ? HelpInfoSections.upload_filled
  //         : HelpInfoSections.upload_empty;
  //       break;
  //     default:
  //       break;
  //   }

  //   dispatch({
  //     type: appActions.SET_HELP_SECTION,
  //     helpSection,
  //   });

  //   return () => {
  //     dispatch({
  //       type: appActions.SET_HELP_SECTION,
  //     });
  //   };
  // }, [selectedTab, vault]);

  // const showBodyContent = () => (
  //   <>
  //     {verifyVaultConditionWarning(vault, selectedTab)}

  //     {VaultTabs.clips === selectedTab &&
  //       (vault.clips?.length ? showClipsBody() : showEmptyPage())}
  //     {VaultTabs.addPrompts === selectedTab && showPlanInterviewBody()}
  //     {VaultTabs.recordAnswers === selectedTab &&
  //       recordOptionSelected === RecordOptions.videoCall &&
  //       showVideoCallWaitingRoomBody()}
  //     {VaultTabs.settings === selectedTab && showAboutVaultBody()}
  //   </>
  // );

  // const learnMoreSubcriptionBodyModal = (
  //   subSchemes: SubscriptionTypeType[],
  // ) => {
  //   const trialScheme = getSubscriptionSchemeById(subSchemes, 'trial');

  //   const { permissions } = trialScheme!;
  //   const usersCallTimeInMinutes = convertSecondsToTimeUnit(
  //     permissions?.usersCallTime!,
  //     TimeUnit.minutes,
  //   );

  //   return (
  //     <div className={styles.learMoreSubscriptionBody}>
  //       <p>
  //         <span className="text__body__regular__medium__gray800">
  //           {' '}
  //           Trial vaults allow you to access in person recording,{' '}
  //         </span>
  //         <span className="text__body__semi__bold__medium__gray800">
  //           {`${usersCallTimeInMinutes} minutes of video call time `}
  //         </span>
  //         <span className="text__body__regular__medium__gray800">
  //           {' '}
  //           for remote recording and up to{' '}
  //         </span>
  //         <span className="text__body__semi__bold__medium__gray800">
  //           {`${vault.maxClips} clips`}
  //         </span>
  //         .
  //       </p>
  //       <p>
  //         Upgrade your vault to access extra video call time for remote
  //         recording and clips.
  //       </p>
  //     </div>
  //   );
  // };

  // const showLearnMoreSubscriptionModalComponent = () => (
  //   <InfoModal
  //     title="Subscription"
  //     content={learnMoreSubcriptionBodyModal(subscriptionsScheme!)}
  //     onClose={() => setShowLearnMoreSubscriptionModal(false)}
  //   />
  // );

  // // ---------------------------- //
  // // INFO: This block of code is a workaround to listen the clicks on the navbar buttons
  // // in order to display the warning modal if the user is recording.

  // const handleClick = (event: MouseEvent) => {
  //   const shouldDisplayWarning =
  //     [VaultTabs.upload, VaultTabs.recordAnswers].includes(selectedTab) &&
  //     !showLeavePageModal &&
  //     (isRecording || isUploading);
  //   const button = event.currentTarget as HTMLButtonElement;
  //   if (shouldDisplayWarning && button) {
  //     event.stopPropagation();
  //     setLeavePageCallback(() => () => button.click());
  //     setShowLeavePageModal(true);
  //   }
  // };

  // useEffect(() => {
  //   const links: NodeListOf<HTMLButtonElement> = document.querySelectorAll(
  //     '#navbar-fixed button',
  //   );

  //   links.forEach((link) => link.addEventListener('click', handleClick));
  //   return () => {
  //     links.forEach((link) => {
  //       link.removeEventListener('click', handleClick);
  //     });
  //   };
  // }, [isRecording, isUploading, selectedTab, showLeavePageModal]);

  // useEffect(
  //   () => () => {
  //     if (isRecording)
  //       dispatchSelfRecording({
  //         type: selfRecordingActions.setIsRecording,
  //         isRecording: false,
  //       });
  //     if (isUploading)
  //       dispatchSelfRecording({
  //         type: selfRecordingActions.setIsUploading,
  //         isUploading: false,
  //       });
  //   },
  //   [isRecording, isUploading],
  // );

  // // ---------------------------- //

  // useEffect(() => {
  //   dispatch({
  //     type: appActions.SET_HELP_LINKS,
  //     helpLinks: {
  //       [HelpInfoLinks.goToRecord]: () => {
  //         moveSelectedTab({ tab: VaultTabs.recordAnswers });
  //         setRecordOptionSelected(RecordOptions.selfRecording);
  //         if (mode === 'upload') {
  //           dispatchSelfRecording({
  //             type: selfRecordingActions.setMode,
  //             mode: 'record',
  //           });
  //         }
  //       },
  //       [HelpInfoLinks.goToUpload]: () =>
  //         moveSelectedTab({ tab: VaultTabs.upload }),
  //       [HelpInfoLinks.goToAddPrompts]: () =>
  //         moveSelectedTab({ tab: VaultTabs.addPrompts }),
  //       [HelpInfoLinks.inviteCollaborators]: () =>
  //         setShowInviteToRecordProcess(true),
  //     },
  //   });
  // }, [vault]);

  // const getUserStatus = () => {
  //   let userRole = '';
  //   // if (isContributor(user, vault)) {
  //   //   userRole = 'Contributor Role';
  //   // } else if (isGuest(user, vault)) {
  //   //   userRole = 'Guest Role';
  //   // }

  //   return (
  //     userRole && (
  //       <div
  //         className={classnames(
  //           styles.userStatus,
  //           'text__body__regular__small__gray500',
  //         )}
  //       >
  //         {userRole.toUpperCase()}
  //       </div>
  //     )
  //   );
  // };

  // const getUserRoles = () => (
  //   <div className={styles.roles}>
  //     {getVaultStatus()}
  //     {getUserStatus()}
  //   </div>
  // );

  // const showNewHeader = () => (
  //   <div className={styles.headerTitle} id="vault-tabs">
  //     {/* ref={tabsRef} into the div */}
  //     {isMobile && getUserRoles()}
  //     <div className={styles.containerRow}>
  //       <div className={styles.leftSection}>
  //         {vault.coverThumbnailUrl ? (
  //           <img
  //             alt="vault-cover"
  //             src={vault.coverUrl}
  //             className={styles.avatar}
  //           />
  //         ) : (
  //           <div className={styles.iconContainer}>
  //             <BookIcon />
  //           </div>
  //         )}
  //         <div>
  //           <div>
  //             <span
  //               className={classnames(
  //                 isMobile
  //                   ? 'text__heading2__mobile__gray800'
  //                   : 'text__heading4__gray800',
  //               )}
  //             >
  //               {vault.title}
  //             </span>
  //             {isOwner(user, vault) && (
  //               <Button
  //                 buttonStyle={ButtonStyle.PrimaryGhost}
  //                 onClick={handleEditVaultModal}
  //                 className={classnames(styles.editButton)}
  //               >
  //                 <EditIcon />
  //               </Button>
  //             )}
  //           </div>

  //           {user.companyName && isContributor(user, vault) && (
  //             <div className="text__body__regular__small__gray500">
  //               Powered by{' '}
  //               <span className="text__body__bold__small__gray700">
  //                 {user.companyName}
  //               </span>
  //             </div>
  //           )}
  //         </div>
  //         {!isMobile && getVaultStatus()}
  //       </div>
  //       <div className={styles.rightSection}>
  //         {!isMobile && !isOwner(user, vault) && getUserStatus()}
  //         {!isMobile && (
  //           <Button
  //             buttonStyle={ButtonStyle.PrimaryStroke}
  //             buttonSize={ButtonSize.Small}
  //             className={classnames(
  //               styles.settingsButton,
  //               VaultTabs.settings === selectedTab ? styles.activeButton : '',
  //             )}
  //             onClick={() => handleTabSelected({ tab: VaultTabs.settings })}
  //           >
  //             <SettingsIcon />
  //             <span className="text__body__semi__bold__small__primary60">
  //               Settings
  //             </span>
  //           </Button>
  //         )}
  //         <div className={styles.rightFromLeftSectionHeader}>
  //           <div
  //             // ref={copyLinkRef}
  //             id="copy-link"
  //             className={classnames(
  //               styles.copyLink,
  //               styles.rightFromLeftSectionHeaderButton,
  //             )}
  //           >
  //             <CopyLink
  //               buttonStyle={ButtonStyle.PrimaryGhost}
  //               className={classnames(styles.linkOption)}
  //               path={`${apiBaseURL}${getRouteFor(RouteName.VaultDetailGuest, {
  //                 id: vault.id,
  //               })}`}
  //               showModalWarning={isTemporaryUser(user)}
  //               copyLinkCallback={() => {
  //                 trackCustomEvent('copyLinkToVault');
  //               }}
  //             >
  //               {isMobile ? (
  //                 <LinkIcon />
  //               ) : (
  //                 <div className={styles.linkOptionActive}>
  //                   <LinkIcon />
  //                 </div>
  //               )}
  //             </CopyLink>
  //           </div>
  //           {shouldShowVaultOptions() && showVaultOptionsButton()}
  //         </div>
  //       </div>
  //     </div>
  //   </div>
  // );

  // A storage-plan vault whose Checkout isn't paid is a locked draft: only
  // the way to pay for it (or delete it), none of the vault.
  if (
    !fetching &&
    vault.subscriptionStatus === SubscriptionStatus.awaitingCheckout
  ) {
    return (
      <DraftVaultCheckout
        vaultId={vault.id}
        title={vault.title}
        onPaid={fetchVault}
      />
    );
  }

  return (
    // <VaultDetailProvider>
    //   {showCardDeclinedModal && (
    //     <ModalCardDeclined
    //       onClose={() => setShowCardDeclinedModal(false)}
    //       openPaymentMethodModal={() => setShowPaymentMethodModal(true)}
    //     />
    //   )}
    //   {showPaymentMethodModal && (
    //     <AddPaymentMethodModal
    //       notifyClose={() => {
    //         setShowPaymentMethodModal(false);
    //       }}
    //       notifySuccess={() => {
    //         setShowPaymentMethodModal(false);
    //         setShowCardDeclinedModal(false);
    //       }}
    //     />
    //   )}
    //   {showBuyClips && (
    //     <BuyClipsProcess
    //       vault={vault}
    //       onFinishProcess={() => setShowBuyClipsModal(false)}
    //       refetchVault={fetchVault}
    //     />
    //   )}
    //   {showRequestVaultDownloadModal && (
    //     <RequestVaultDownloadModal
    //       vault={vault}
    //       onClose={() => setShowRequestVaultDownloadModal(false)}
    //     />
    //   )}
    //   {showEditClipModal && showEditClipModalComponent()}
    //   {showLearnMoreSubscriptionModal &&
    //     showLearnMoreSubscriptionModalComponent()}

    //   {showQrCodesModal && (
    //     <QrCodesDetailsModal
    //       qrCodes={vault.qrCodes}
    //       onClose={() => setShowQrCodesModal(false)}
    //       vault={vault}
    //     />
    //   )}
    //   {showQrCodesExplanationModal && (
    //     <QrCodesExplanationModal
    //       onClose={() => setShowQrCodesExplanationModal(false)}
    //     />
    //   )}
    //   {showModalSignUp && (
    //     <ModalWarning
    //       title="Sign up to share or download your recordings"
    //       content={
    //         <div className={styles.modalSignUpInfo}>
    //           <div className="text__body__regular__medium__gray800">
    //             Please complete the sign up process to share or download your
    //             clips, as well as access the rest of our features.
    //           </div>
    //           <div className="text__body__regular__medium__gray800">
    //             Don’t worry, your first vault is{' '}
    //             <span className="text__body__semi__bold__medium__gray800">
    //               free
    //             </span>{' '}
    //             for a month, and signing up only takes 2 minutes!
    //           </div>
    //         </div>
    //       }
    //       successButtonText="Sign up"
    //       closeFn={() => setModalSignUp(false)}
    //       successFn={() => goToPage(RouteName.SignUp)}
    //       successStyleButton={ButtonStyle.PrimaryFilled}
    //     />
    //   )}

    //   {showLeavePageModal && (
    //     <ModalWarning
    //       title="Leaving page"
    //       content={
    //         <div className="text__body__regular__medium__gray800">
    //           Are you sure you want to leave this page? If you leave your
    //           {isRecording ? ' recording' : ' upload'} will be cancelled.
    //         </div>
    //       }
    //       successButtonText={`Leave & cancel ${
    //         isRecording ? 'recording' : 'upload'
    //       }`}
    //       successStyleButton={ButtonStyle.RedFilled}
    //       closeFn={() => setShowLeavePageModal(false)}
    //       successFn={() => {
    //         dispatchSelfRecording({
    //           type: selfRecordingActions.cleanState,
    //         });
    //         setShowLeavePageModal(false);
    //         leavePageCallback?.();
    //       }}
    //     />
    //   )}
    //   {showModalLeaveTemporary && (
    //     <ModalTemporaryUser onClose={() => setShowModalLeaveTemporary(false)} />
    //   )}
    //   {showInviteToRecordProcess && (
    //     <InviteToRecordProcess
    //       handleClose={() => setShowInviteToRecordProcess(false)}
    //     />
    //   )}
    <div className={classnames(styles.mainContainer)}>
      {fetching ? (
        <Spinner />
      ) : (
        <div className={styles.vaultDetailContainer}>
          {showOnboardingFinalModal && showOnboardingModal()}
          {startPaymentProcess && showAllPaymentProcessComponent()}
          {showCardDeclinedModal && (
            <ModalCardDeclined
              onClose={() => setShowCardDeclinedModal(false)}
              openPaymentMethodModal={() => setShowPaymentMethodModal(true)}
            />
          )}
          {showPaymentMethodModal && (
            <AddPaymentMethodModal
              notifyClose={() => {
                setShowPaymentMethodModal(false);
              }}
              notifySuccess={() => {
                setShowPaymentMethodModal(false);
                setShowCardDeclinedModal(false);
              }}
            />
          )}
          <VaultTopBar
            vault={vault}
            breadcrumb={vaultPageBreadcrumb(routeVaultId, selectedTab)}
            bottomNav={{ selectedTab, onSelectTab: changeTab }}
          />
          <VaultTabsBar selectedTab={selectedTab} onSelectTab={changeTab} />
          <div className={styles.tabsContainer}>{showTabs()}</div>
          {/* <div className={classnames(styles.bodyContent)}>
              {subscriptionsScheme && showBodyContent()}
            </div> */}
        </div>
      )}
    </div>
  );
};

const VaultDetail: React.FC = () => (
  <VaultDetailProvider>
    <VaultDetailContent />
  </VaultDetailProvider>
);

export { VaultDetail };
